import { ArcaptchaWidget } from 'arcaptcha-react';

export default function ArCaptcha(props) { // RAGBOT: New component
  return (
    <ArcaptchaWidget
      site-key={props.siteKey}
      callback={props.onSubmit}
      theme={props.theme}
    />
  );
}
